<div layout="row" class="layout-row full-height">
  <span class="br-body-2" [ngbTooltip]="agent.agentReferences ? tooltipTmpl : null" openDelay="300" triggers="hover">
    {{agent.assistant ? ('AGENT_MODE.assistant' | translate) : (agent.agentReferences?.length ? ('AGENT_MODE.primary'| translate) : '---')}}
    {{agent.agentReferences?.length ? '(' + agent.agentReferences?.length + ')' : ''}}
  </span>

  <ng-template #tooltipTmpl>
    <div class="layout-column layout-align-start-center">
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 margin-right-5 agent-color">{{'Agent' | translate}}:</span>
        <span class="br-body-1">{{agent.assistant ? ({firstName: agent.agentReferences[0].firstName, lastName: agent.agentReferences[0].lastName} | userName) : (agent.user | userName)}}</span>
      </div>

      <div class="layout-row layout-align-start-center"
           *ngIf="agent.assistant && agent.agentReferences?.length">
        <span class="br-body-2 margin-right-5 assistant-color">{{'Assistants' | translate}}:</span>
        <div class="br-body-1" *ngFor="let assistant of agent.agentReferences; let last = last">
          <span>{{{firstName: assistant.firstName, lastName: assistant.lastName} | userName}}</span>
          <span *ngIf="!last" class="margin-right-5">|</span>
        </div>
      </div>

    </div>

  </ng-template>
</div>
